import { render, staticRenderFns } from "./vSeguimientoSolicitud.vue?vue&type=template&id=2cebbdcd&scoped=true&"
import script from "./vSeguimientoSolicitud.vue?vue&type=script&lang=js&"
export * from "./vSeguimientoSolicitud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cebbdcd",
  null
  
)

export default component.exports